import React from 'react';
import { Box, Typography, Paper, Container, Divider } from '@mui/material';

const TermsAndConditions = ({ onNavigate, isDialog }) => {
    return (
        <Container
            maxWidth={isDialog ? false : "lg"}
            disableGutters={isDialog}
            sx={isDialog ? {} : { mt: 4, mb: 6 }}
        >
            <Paper elevation={isDialog ? 0 : 3} sx={isDialog ? {} : { p: 4, borderRadius: 2 }}>
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{ fontWeight: 'bold', color: '#11224d', mb: 2 }}
                >
                    Terms & Conditions
                </Typography>

                <Typography variant="body2" sx={{ mb: 2, color: '#555' }}>
                    ShipperDock Loadboard Platform <br />
                    Owned and operated by <strong>Goodlanes Transportation Services LLC</strong>
                </Typography>

                <Typography variant="body2" sx={{ mb: 3, color: '#777', fontStyle: 'italic' }}>
                    Last Updated: September 28, 2025
                </Typography>

                <Divider sx={{ mb: 3 }} />

                <Box sx={{ color: '#333' }}>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        1. Acceptance of Terms
                    </Typography>
                    <Typography variant="body1" paragraph>
                        By accessing or using the ShipperDock platform, you acknowledge that you have read,
                        understood, and agree to be bound by these Terms & Conditions and our{' '}
                        <span
                            style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => onNavigate && onNavigate('Privacy Policy')}
                        >
                            Privacy Policy
                        </span>.
                        If you are using the Platform on behalf of a company, you represent that you are authorized to bind that entity.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        2. Platform Nature and Role Disclaimer
                    </Typography>
                    <Typography variant="body1" paragraph>
                        ShipperDock is a technology platform only. We do not act as a freight broker, motor carrier,
                        shipper, dispatcher, freight forwarder, factoring company, escrow service, or payment guarantor.
                        We do not arrange transportation, negotiate rates, verify creditworthiness, guarantee payment,
                        or ensure shipment performance. All transactions occur solely between users.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        3. No Partnership or Agency
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Use of the Platform does not create any partnership, joint venture, agency, employment,
                        or fiduciary relationship between you and ShipperDock or Goodlanes Transportation Services LLC.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        4. Eligibility, Accounts, and Compliance
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You must be at least 18 years of age to use the Platform. You are solely responsible for maintaining
                        all required licenses, permits, DOT or MC authority, insurance coverage, and compliance with applicable laws.
                        You are responsible for all activity conducted under your account. While ShipperDock may perform verification
                        of certain credentials or authority information at the time of review, such verification does not constitute
                        a guarantee of ongoing compliance, validity, or performance by any user.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        5. User Content and License
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You retain ownership of content you post, including loads, trucks, and messages. By posting content,
                        you grant ShipperDock a non-exclusive, worldwide, royalty-free license to use, display, and distribute
                        such content solely for operating and improving the Platform.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        6. Assumption of Risk
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Freight transportation and commercial transactions involve inherent risks, including fraud, non-payment,
                        delays, cancellations, misrepresentation, and business loss. You knowingly assume all risks arising from
                        your use of the Platform. ShipperDock is not responsible for resolving disputes, enforcing agreements,
                        or mediating claims between users.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        7. No Guarantees
                    </Typography>
                    <Typography variant="body1" paragraph>
                        ShipperDock makes no guarantees regarding load availability, truck availability, pricing, earnings,
                        payment timing, or business success. Use of the Platform does not guarantee revenue or outcomes.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        8. Subscriptions, Billing, and Refunds
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Access to the Platform is provided on a subscription basis. All fees are non-refundable except where
                        required by law. Cancellation stops future billing only. ShipperDock is not responsible for failures
                        or disputes caused by third-party payment processors.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        9. Prohibited Conduct
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You agree not to post false, misleading, or fraudulent information; scrape, harvest, or misuse platform data;
                        circumvent security or access controls; or use the Platform for unlawful purposes. Violations may result
                        in suspension or termination of access without refund.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        10. Third-Party Services
                    </Typography>
                    <Typography variant="body1" paragraph>
                        The Platform may integrate third-party services such as payment processors or mapping tools.
                        ShipperDock is not responsible for the availability, accuracy, or failures of third-party services.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        11. Security Disclaimer
                    </Typography>
                    <Typography variant="body1" paragraph>
                        While we implement commercially reasonable safeguards, no system is completely secure.
                        Use of the Platform is at your own risk.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        12. Limitation of Liability
                    </Typography>
                    <Typography variant="body1" paragraph>
                        To the maximum extent permitted by law, ShipperDock and Goodlanes Transportation Services LLC
                        shall not be liable for indirect, incidental, consequential, or punitive damages. Our total
                        liability shall not exceed the fees paid by you in the thirty (30) days preceding the claim.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        13. Indemnification
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You agree to indemnify and hold harmless ShipperDock, Goodlanes Transportation Services LLC,
                        and their affiliates from claims arising from your use of the Platform or violation of these Terms.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        14. Arbitration and Class Action Waiver
                    </Typography>
                    <Typography variant="body1" paragraph>
                        All disputes shall be resolved through binding arbitration on an individual basis.
                        You waive any right to a jury trial or participation in a class action.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        15. Termination
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We may suspend or terminate access to the Platform at any time, with or without notice,
                        and without refund. Upon termination, all licenses granted to you immediately cease.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        16. Governing Law
                    </Typography>
                    <Typography variant="body1" paragraph>
                        These Terms are governed by the laws of the State of Wyoming, United States,
                        without regard to conflict-of-law principles.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#11224d' }}>
                        17. Contact Information
                    </Typography>
                    <Typography variant="body1" paragraph>
                        For legal inquiries, please contact us at:<br />
                        <strong>support@shipperdock.com</strong>
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="body2" sx={{ textAlign: 'center', color: '#666' }}>
                        © 2025 Goodlanes Transportation Services LLC. All Rights Reserved.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default TermsAndConditions;
